/**
 * @generated SignedSource<<d29f94685980ccb4905b42bd7ba343c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DelegatedAdminJiraSection$data = {
  readonly jira?: {
    readonly canManageCustomOnboarding: boolean | null;
  } | null;
  readonly " $fragmentType": "DelegatedAdminJiraSection";
};
export type DelegatedAdminJiraSection$key = {
  readonly " $data"?: DelegatedAdminJiraSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegatedAdminJiraSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skipDelegatedAdminCheck"
    }
  ],
  "kind": "Fragment",
  "name": "DelegatedAdminJiraSection",
  "selections": [
    {
      "condition": "skipDelegatedAdminCheck",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "alias": "canManageCustomOnboarding",
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                },
                {
                  "kind": "Literal",
                  "name": "key",
                  "value": "MANAGE_CUSTOM_ONBOARDING"
                }
              ],
              "kind": "ScalarField",
              "name": "hasGlobalPermission"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "4829d8ab2a5bd80527220204076e7d6a";

export default node;
